import { useRouter } from 'next/router'
import { stringify } from 'query-string'

import type { GetTopicDetails } from 'utils/hooks/useTopicDetails'

import { EmptyState } from 'components/EmptyState'
import GenericList from 'components/GenericList'
import ModuleCard from 'components/Module/ModuleCard'
import ModulePlaceholder from 'components/Module/ModulePlaceholder'
import TopicInfo from 'components/Topic/TopicInfo'

const TopicContent = ({ data }: { data: GetTopicDetails }) => {
  const { query } = useRouter()
  const { topik } = query
  const { from = 'topik', menuId = topik } = query

  return (
    <>
      <div className="px-3 relative">
        <GenericList
          className="relative"
          beforeList={
            <div className="mb-4">
              <TopicInfo
                pointers={data?.topicData?.values}
                shouldShowTab={Boolean(data?.topicData?.contextualizedPageId)}
              />
            </div>
          }
          data={data?.moduleWithProgress}
          dataState={data?.fetchStatus}
          loadingComponent={
            <div className="pt-4">
              <ModulePlaceholder amount={3} />
            </div>
          }
          emptyComponent={
            <EmptyState
              title="Konten belum tersedia"
              description="Belum ada topik yang dapat dipelajari saat ini, silahkan coba lagi nanti."
            />
          }
          renderItem={(
            { id, name, duration, totalMaterial, progress, badgeText },
            index
          ) => (
            <div>
              <ModuleCard
                id={id}
                number={index + 1}
                name={name}
                duration={duration}
                totalMaterial={totalMaterial}
                isLocked={!progress?.prerequisiteCompleted}
                isCompleted={!!progress?.material}
                badgeText={badgeText}
                href={
                  `/modul/?` +
                  stringify({
                    modul: id,
                    topik: query.topik,
                    topik_name: data?.topicData?.name,
                    from,
                    menuId,
                  })
                }
              />
            </div>
          )}
          listKey={({ id }) => id}
        />
      </div>
    </>
  )
}

export default TopicContent
